const PERMISSION_KEY= "core:config_system";
const PAGE_URL = {
    CONFIG_SYSTEM_PAGE: "/admin/core/cache-system"
}

export {PERMISSION_KEY, PAGE_URL}

